import React from 'react'

const SVG = ({
  style = {},
  viewBox = '0 0 625 100',
  width = '625',
  height = '100',
  className = '',
  ...rest
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns='http://www.w3.org/2000/svg'
    viewBox={viewBox}
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...rest}
  >
    <defs><clipPath><rect width="625" height="100"/></clipPath></defs><g><rect width="625" height="100"/></g>
  </svg>
)
export default SVG

// <!-- <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 625 100"><defs><style>.a{clip-path:url(#b);}</style><clipPath id="b"><rect width="625" height="100"/></clipPath></defs><g id="a" class="a"><rect width="625" height="100"/></g></svg> -->
